// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3Z66R","boxTitle":"Qualiphy_boxTitle__2feej","box":"Qualiphy_box__3mxYa","toggleWrap":"Qualiphy_toggleWrap__17wJG"};